import React from "react";

const Laporan = () => {
  const reports = [
    {
      title: "Laporan Valuasi Aktuaris DPTA 31 Desember 2024",
      category: "Laporan",
      image: "/images/asset/cover-lapke.svg",
      file: "/pdfs/Laporan Valuasi Aktuaris DPTA 31 desember 2024_web.pdf",
    },
    {
      title: "Laporan Pengawasan Kinerja Investasi 2024",
      category: "Laporan",
      image: "/images/asset/cover-lapke.svg",
      file: "/pdfs/Laporan Pengawasan Kinerja Investasi 2024.web.pdf",
    },
    {
      title: "PDP 2019",
      category: "Laporan",
      image: "/images/asset/cover-lapke.svg",
      file: "/pdfs/PDP 2019_rotated.pdf",
    },
  ];
  return (
    <>
      <div className="px-4 py-6 sm:px-6 lg:px-12 xl:px-20">
        <h2 className="text-xl font-bold mb-6 font-pontano">Laporan Terkait Dana Pensiun Toyota Astra</h2>
        <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
          {reports.map((report, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-lg shadow hover:shadow-md transition duration-300 flex flex-col overflow-hidden"
            >
              <img
                src={report.image}
                alt={report.title}
                className="w-full h-[300px] object-cover object-center"
              />
              <div className="flex flex-col p-4 justify-between grow">
                <div className="mb-4">
                  <p className="text-sm text-[#EB0A1E] font-medium mb-1 font-inter">
                    {report.category}
                  </p>
                  <h3 className="text-base font-semibold leading-snug font-pontano">
                    {report.title}
                  </h3>
                </div>
                <a
                  href={report.file}
                  download
                  className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#EB0A1E] text-white text-sm rounded-md hover:bg-red-700 transition self-start font-inter"
                >
                  Download
                  <img
                    src="/images/asset/download.svg"
                    alt="Download"
                    className="w-4 h-4"
                  />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Laporan;
